import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {
	AttributeType,
	ConfigurationInterpreter
} from '@viamedici-spc/configurator-ts';

import {hoverInfo, widgetButton} from '../../css/styleSets';
import {SpcBaseValue} from './spcBaseValue';

@customElement('spc-boolean-value')
export class SpcBooleanValue extends SpcBaseValue {

	static styles = [
		widgetButton,
		hoverInfo,
		css`
			:host {
				flex-grow: 1;
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
				flex-grow: 1;
			}

			.hidden {
				display: none;
			}
		`];

	stateChanged(state) {
		super.stateChanged(state);
		this.attribute = ConfigurationInterpreter.getBooleanAttribute(this.spcConfiguration, this.attributeId);
	}

	makeDecision() {
		this.session.makeDecision({
				type: AttributeType.Boolean,
				attributeId: this.attributeId,
				state: this.value.id
			}
		);
	}

	isIncluded() {
		return this.attribute.decision?.state === this.value.id;
	}

	isAllowed() {
		return true;
	}

	render() {
		if (!this.value) return null;
		return html`
			<div class="item ${classMap({selected: this.isIncluded(), disabled: !this.isAllowed(), fixed: !this.canBeExcluded(), hidden: !this.isVisible()})}">
				<button @click="${this.makeDecision}">${this.label()}</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">${this.getInfoText()}</div>
					</div>
				`)}

			</div>
		`;
	}
}
